async function importKey(format, keyData, algorithm, extractable, keyUsages) {
    return crypto.subtle.importKey(
        format,
        keyData,
        algorithm,
        extractable,
        keyUsages
    );
}

async function rsaEncrypt(data, key) {
    var keyObject = await importKey(
        'spki',
        base64ToUint8Array(key),
        { name: 'RSA-OAEP', hash: { name: 'SHA-256' } },
        true,
        ['encrypt']
    );
    var encodedData = await crypto.subtle.encrypt(
        {
            name: 'RSA-OAEP',
            hash: { name: 'SHA-256' },
        },
        keyObject,
        encodeData(data)
    );
    return Uint8ArrayToBase64(encodedData);
}

function stringToUint8Array(data) {
    return Uint8Array.from(data, (c) => c.charCodeAt(0));
}

function Uint8ArrayToString(data) {
    return String.fromCharCode.apply(null, data);
}

function binaryToBase64(data) {
    return btoa(data);
}

function base64ToBinary(data) {
    return atob(data);
}

function encodeData(data) {
    return new TextEncoder('utf-8').encode(data);
}

function decodeData(data) {
    return new TextDecoder('utf-8').decode(data);
}

function base64ToUint8Array(key) {
    const binaryKey = base64ToBinary(key);
    const Uint8ArrayKey = stringToUint8Array(binaryKey);
    return Uint8ArrayKey;
}

function Uint8ArrayToBase64(data) {
    const stringData = Uint8ArrayToString(new Uint8Array(data));
    const base64Data = binaryToBase64(stringData);
    return base64Data;
}

function getDatetime() {
    // Create a new Date object
    var currentDate = new Date();

    // Extract the date components
    var day = currentDate.getDate();
    var month = currentDate.getMonth() + 1; // Months are zero-based, so January is 0
    var year = currentDate.getFullYear();

    // Extract the time components
    var hours = currentDate.getHours();
    var minutes = currentDate.getMinutes();
    var seconds = currentDate.getSeconds();

    // Construct the date string
    var datetime = '' + year + month + day + hours + minutes + seconds;

    // Display the date and time
    return datetime;
}

function getSelectedRadioValue(groupName) {
    const radioButtons = document.querySelectorAll(
        `input[type="radio"][name="${groupName}"]:checked`
    );
    return radioButtons.length > 0 ? radioButtons[0].value : '';
}

export async function encryptFormData(params) {
    const { publicKey, formData } = params;

    //Get form data
    const first_name = formData.first_name;
    const last_name = formData.last_name;
    const date_of_birth = formData.date_of_birth;
    const gender = formData.gender;
    const father = formData.father;
    const mother = formData.mother;
    const city = formData.city;
    const street = formData.street;
    const house_number = formData.house_number;
    const zip_code = formData.zip_code;
    const mobile = formData.mobile;
    const landline = formData.landline;
    const email = formData.email;
    const fallback_contact = formData.fallback_contact;
    const fallback_number = formData.fallback_number;
    const swimming_allowed = formData.swimming_allowed;
    const swimming_capability = formData.swimming_capability;
    const swimming_badge = formData.swimming_badge;
    const tools_allowed = formData.tools_allowed;
    const vaccination_tetanus = formData.vaccination_tetanus;
    const vaccination_tetanus_year = formData.vaccination_tetanus_year;
    const vaccination_fsme = formData.vaccination_fsme;
    const vaccination_fsme_year = formData.vaccination_fsme_year;
    const tick_removal_allowed = formData.tick_removal_allowed;
    const allergies = formData.allergies;
    const vegetarian = formData.vegetarian;
    const food_intolerance = formData.food_intolerance;
    const medication_allowed = formData.medication_allowed;
    const medication = formData.medication;
    const friend_1 = formData.friend_1;
    const friend_2 = formData.friend_2;
    const siblings_in_same_tent = formData.siblings_in_same_tent;
    const additional_details = formData.additional_details;
    const downloaded_consent_form = formData.downloaded_consent_form;
    const is_fee_paid = formData.is_fee_paid;
    const fee_amount = formData.fee_amount;
    const agreement_signed = formData.agreement_signed;
    const media_allowed = formData.media_allowed;
    const confirmation_email_sent = formData.confirmation_email_sent;
    const is_archived = formData.is_archived;
    const payment_date = formData.payment_date;

    // Encrypt each form value

    const encryptedData = {
        first_name: await rsaEncrypt(first_name, publicKey),
        last_name: await rsaEncrypt(last_name, publicKey),
        date_of_birth: await rsaEncrypt(date_of_birth, publicKey),
        gender: await rsaEncrypt(gender, publicKey),
        father: await rsaEncrypt(father, publicKey),
        mother: await rsaEncrypt(mother, publicKey),
        city: await rsaEncrypt(city, publicKey),
        street: await rsaEncrypt(street, publicKey),
        house_number: await rsaEncrypt(house_number, publicKey),
        zip_code: await rsaEncrypt(zip_code, publicKey),
        mobile: await rsaEncrypt(mobile, publicKey),
        landline: await rsaEncrypt(landline, publicKey),
        email: await rsaEncrypt(email, publicKey),
        fallback_contact: await rsaEncrypt(fallback_contact, publicKey),
        fallback_number: await rsaEncrypt(fallback_number, publicKey),
        swimming_allowed: await rsaEncrypt(swimming_allowed, publicKey),
        swimming_capability: await rsaEncrypt(swimming_capability, publicKey),
        swimming_badge: await rsaEncrypt(swimming_badge, publicKey),
        tools_allowed: await rsaEncrypt(tools_allowed, publicKey),
        vaccination_tetanus: await rsaEncrypt(vaccination_tetanus, publicKey),
        vaccination_tetanus_year: await rsaEncrypt(
            vaccination_tetanus_year,
            publicKey
        ),
        vaccination_fsme: await rsaEncrypt(vaccination_fsme, publicKey),
        vaccination_fsme_year: await rsaEncrypt(
            vaccination_fsme_year,
            publicKey
        ),
        tick_removal_allowed: await rsaEncrypt(tick_removal_allowed, publicKey),
        allergies: await rsaEncrypt(allergies, publicKey),
        vegetarian: await rsaEncrypt(vegetarian, publicKey),
        food_intolerance: await rsaEncrypt(food_intolerance, publicKey),
        medication_allowed: await rsaEncrypt(medication_allowed, publicKey),
        medication: await rsaEncrypt(medication, publicKey),
        friend_1: await rsaEncrypt(friend_1, publicKey),
        friend_2: await rsaEncrypt(friend_2, publicKey),
        siblings_in_same_tent: await rsaEncrypt(
            siblings_in_same_tent,
            publicKey
        ),
        additional_details: await rsaEncrypt(additional_details, publicKey),
        downloaded_consent_form: await rsaEncrypt(
            downloaded_consent_form,
            publicKey
        ),
        is_fee_paid: await rsaEncrypt(is_fee_paid, publicKey),
        fee_amount: await rsaEncrypt(fee_amount, publicKey),
        agreement_signed: await rsaEncrypt(agreement_signed, publicKey),
        media_allowed: await rsaEncrypt(media_allowed, publicKey),
        confirmation_email_sent: await rsaEncrypt(
            confirmation_email_sent,
            publicKey
        ),
        is_archived: await rsaEncrypt(is_archived, publicKey),
        payment_date: await rsaEncrypt(payment_date, publicKey),
    };

    return encryptedData;
}

export async function encryptUtility(params) {
    const { publicKey, formData } = params;

    const encryptField = async (fieldValue) => {
        return await rsaEncrypt(fieldValue, publicKey);
    };

    const encryptedData = {};

    for (const key in formData) {
        if (formData.hasOwnProperty(key)) {
            encryptedData[key] = await encryptField(formData[key]);
        }
    }

    return encryptedData;
}

export async function encryptAllFormData({ publicKey, formData }) {
    const encryptedData = {};

    for (const [key, value] of Object.entries(formData)) {
        if (Array.isArray(value)) {
            if (typeof value[0] === 'object' && value[0] !== null) {
                encryptedData[key] = await Promise.all(
                    value.map(async (obj) => {
                        const encryptedObj = {};
                        for (const [innerKey, innerValue] of Object.entries(
                            obj
                        )) {
                            encryptedObj[innerKey] = await rsaEncrypt(
                                innerValue,
                                publicKey
                            );
                        }
                        return encryptedObj;
                    })
                );
            } else {
                // Encrypt primitive array items
                encryptedData[key] = await Promise.all(
                    value.map((item) => rsaEncrypt(item, publicKey))
                );
            }
        } else if (typeof value === 'object' && value !== null) {
            encryptedData[key] = await encryptAllFormData({
                publicKey,
                formData: value,
            });
        } else {
            encryptedData[key] = await rsaEncrypt(value, publicKey);
        }
    }

    return encryptedData;
}

export async function encryptSingleFormData({ publicKey, formData }) {
    const encryptedData = {};

    for (const [key, value] of Object.entries(formData)) {
        if (key === 'id') {
            encryptedData[key] = value;
            continue;
        }

        if (Array.isArray(value)) {
            encryptedData[key] = await Promise.all(
                value.map(async (item) => {
                    if (typeof item === 'object' && item !== null) {
                        const encryptedItem = {};
                        for (const [nestedKey, nestedValue] of Object.entries(
                            item
                        )) {
                            encryptedItem[nestedKey] =
                                nestedKey === 'id'
                                    ? nestedValue
                                    : await rsaEncrypt(nestedValue, publicKey);
                        }
                        return encryptedItem;
                    }
                    return await rsaEncrypt(item, publicKey);
                })
            );
        } else if (typeof value === 'object' && value !== null) {
            encryptedData[key] = {};
            for (const [nestedKey, nestedValue] of Object.entries(value)) {
                encryptedData[key][nestedKey] =
                    nestedKey === 'id'
                        ? nestedValue
                        : await rsaEncrypt(nestedValue, publicKey);
            }
        } else {
            encryptedData[key] = await rsaEncrypt(value, publicKey);
        }
    }

    return encryptedData;
}
